/* global localStorage */

import axios from 'axios'
import { camelizeKeys, decamelizeKeys } from 'humps';
import router from '../../routes/router'
import store from '../../store'
import swal from '../../services/swal'


const API_HOST = process.env.VUE_APP_API_HOST || 'https://neu.flatkalkulator.de'
const API_URL = process.env.API_URL || API_HOST+'/api/v1'

const ax = axios.create({
  baseURL: API_URL,
})

ax.interceptors.request.use(
  config => {
      const token = localStorage.token; 
      if (token) {
          config.headers['Authorization'] = 'Bearer ' + token;
      }
      config.headers['Content-Type'] = 'application/json';
//      config.headers['Access-Control-Allow-Origin'] = API_HOST 
      config.headers['Access-Control-Allow-Origin'] = '*'; 
//      axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

      if (config.data) {
        config.data = decamelizeKeys(config.data);
      }
      return config;
  },
  error => {
      Promise.reject(error)
  });

ax.interceptors.response.use(
  function(response) { return response;}, 
  function(error) {

      if (error.response) {

        if (error.response.status == '401'){
          swal.error('Logout', "Sie wurden abgemeldet und werden zum Login umgeleitet.");
          store.dispatch('logout');
          router.push('/login');
          delete localStorage.token
        }

        if (error.response.status == '500'){
          swal.error('Serverfehler', "Ein Serverfehler ist aufgetreten, bitte wenden Sie sich an den Support.");
        }
/*
        swal.error('Kommunikationsfehler', error.code);
        console.log(error)
        console.log(error.response)
          alert(error.response.data.message);
*/
        }
  });

export default ax